import React, { useState } from "react";
import { Link } from 'react-router-dom';
import "./RequestDemo.css";
import { submitForm } from '../utils/forms';

const RequestDemo = () => {
  const [submitted, setSubmitted] = useState(false);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '', email: '', company: '', role: '', size: '50-200',
    interest: 'AI Strategy', timeline: '0-3 months', goal: '', website: '',
  });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      const result = await submitForm('consultation', form);
      setSubmitted(true);
      setStatus(result.fallback ? 'fallback' : 'success');
    } catch (err) {
      setError(err.message);
      setStatus('error');
    }
  };

  return (
    <div className="rd-page page-shell">
      <section className="rd-hero section-dark">
        <span className="aurora-orb hero-orb-a" />
        <span className="aurora-orb hero-orb-b" />
        <div className="site-container-wide">
          <span className="section-eyebrow">Book Consultation</span>
          <h1>
            Tell us your goal. <span className="gradient-text serif-accent">We will tell you the path.</span>
          </h1>
          <p>
            A 30-minute discovery call with a senior Dalytix partner. No slides, no sales pitch — just a
            conversation about your goal, your data, and the right path forward.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide rd-grid">
          <div className="rd-form-wrap professional-card">
            {!submitted ? (
              <form className="professional-form" onSubmit={onSubmit}>
                <h2>Book your consultation</h2>
                <div className="rd-row">
                  <div>
                    <label htmlFor="name">Full name</label>
                    <input id="name" name="name" value={form.name} onChange={onChange} required />
                  </div>
                  <div>
                    <label htmlFor="email">Work email</label>
                    <input id="email" name="email" type="email" value={form.email} onChange={onChange} required />
                  </div>
                </div>
                <div className="rd-row">
                  <div>
                    <label htmlFor="company">Company</label>
                    <input id="company" name="company" value={form.company} onChange={onChange} required />
                  </div>
                  <div>
                    <label htmlFor="role">Role / title</label>
                    <input id="role" name="role" value={form.role} onChange={onChange} required />
                  </div>
                </div>
                <div className="rd-row">
                  <div>
                    <label htmlFor="size">Company size</label>
                    <select id="size" name="size" value={form.size} onChange={onChange}>
                      <option>1-50</option>
                      <option>50-200</option>
                      <option>200-1,000</option>
                      <option>1,000-10,000</option>
                      <option>10,000+</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="timeline">Timeline</label>
                    <select id="timeline" name="timeline" value={form.timeline} onChange={onChange}>
                      <option>0-3 months</option>
                      <option>3-6 months</option>
                      <option>6-12 months</option>
                      <option>Just exploring</option>
                    </select>
                  </div>
                </div>
                <label htmlFor="interest">Primary interest</label>
                <select id="interest" name="interest" value={form.interest} onChange={onChange}>
                  <option>AI Strategy &amp; Operating Model</option>
                  <option>Generative AI &amp; Agents</option>
                  <option>Data Engineering &amp; Lakehouse</option>
                  <option>MLOps &amp; Production AI</option>
                  <option>Analytics, BI &amp; Decision Intelligence</option>
                  <option>Data Governance &amp; Trust</option>
                  <option>Cloud Data Modernization</option>
                  <option>Computer Vision &amp; Edge AI</option>
                  <option>AI Security &amp; Responsible AI</option>
                </select>
                <label htmlFor="goal">What outcome are you hoping to achieve?</label>
                <textarea id="goal" name="goal" rows="5" value={form.goal} onChange={onChange} required />
                <label className="form-honeypot" htmlFor="demo-website">Website</label>
                <input id="demo-website" name="website" value={form.website} onChange={onChange} tabIndex="-1" autoComplete="off" className="form-honeypot" />
                {error && <p className="form-error">{error}</p>}
                <button type="submit" className="btn-primary-large" disabled={status === 'loading'}>
                  {status === 'loading' ? 'Sending...' : 'Request consultation'}
                </button>
                <small>A senior partner will reply within one business day.</small>
              </form>
            ) : (
              <div className="rd-thanks">
                <span className="rd-check">✓</span>
                <h2>{status === 'fallback' ? 'Your email client is ready.' : 'Thanks — your request is in.'}</h2>
                <p>{status === 'fallback' ? 'We opened a prepared email because no form endpoint is configured yet. Send it from your email client and a senior Dalytix partner will reply.' : 'A senior Dalytix partner will be in touch within one business day to schedule a 30-minute discovery call.'}</p>
                <Link to="/insights" className="btn-outline btn-arrow">Read the briefing</Link>
              </div>
            )}
          </div>

          <aside className="rd-aside">
            <div className="rd-card">
              <h3>What to expect</h3>
              <ul>
                <li>30-minute call with a partner</li>
                <li>No slides, no sales pitch</li>
                <li>Concrete recommendations on the call</li>
                <li>Optional written follow-up brief</li>
              </ul>
            </div>
            <div className="rd-card">
              <h3>Why teams choose Dalytix</h3>
              <ul>
                <li>Senior practitioners on every engagement</li>
                <li>Production, governance and handover planned from day one</li>
                <li>Experience across regulated and data-intensive environments</li>
                <li>Clear recommendations before a proposal is written</li>
              </ul>
            </div>
            <div className="rd-card highlight">
              <h3>Prefer email?</h3>
              <p>Reach us directly — a partner replies personally.</p>
              <a href="mailto:hello@dalytix.com">hello@dalytix.com</a>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default RequestDemo;
